module.exports = __webpack_public_path__ + "img/gs1.7b8a3ab6.png";